export default {
  'department.department': '部門　',
  'department.name': '部門名',
  'department.perisanname': 'ペルシア語の学部名',
  'department.englishname': '英語の学部名',
  'department.code': '部門コード',
  'department.add': '部門を追加',
  'department.title': '部門の管理',
  'department.departmentdel': '部門の削除',
  'department.departmentadd': '部門の追加が完了しました',
  'department.departmentdelete': '部門の削除が完了しました',
  'department.deleteerror': 'レコードが他のレコードによって使用されています',
  'department.departmentaddInformation': 'あなたの情報は正常に編集されました',
};
